
<app-user-dashboard [fullScreen]="true">
  <div class="bg-container">
    <div class="container">
      <div class="card">
        <div class="section-info">
          <h2 class="title-card">
            {{'InfoMarketplaceAndDirectSale.TitleCard1' | translate}}
          </h2>
          <p class="text-card">
            {{'InfoMarketplaceAndDirectSale.TextCard1' | translate}}

          </p>
        </div>
        <div class="section-img">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/marketplace.png" style="width: 100%" alt="flag"/>
          </figure>
        </div>
      </div>
      <div class="card">
        <div class="section-info">
          <h2 class="title-card">
            {{'InfoMarketplaceAndDirectSale.TitleCard2' | translate}}
          </h2>
          <p class="text-card">
            {{'InfoMarketplaceAndDirectSale.TextCard2' | translate}}

          </p>
        </div>
        <div class="section-img">
          <figure class="figure-img">
            <img src="../../../../assets/img/process_fruzty/direct_sales.png" style="width: 100%" alt="flag"/>
          </figure>
        </div>
      </div>
    </div>
  </div>

</app-user-dashboard>

<app-footer-home></app-footer-home>
